import { FormattedMessage } from 'react-intl';
import { store } from 'Models/Store';
import { newAlertModal } from 'Views/Components/Modal/NewAlertModal';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';

export async function ProcessResults(res: string, cancellation: boolean): Promise<boolean> {
	if (res.includes('departed') || res.includes('checked in')) {
		const departed = res.includes('departed');

		if (store.isStaff) {
			const confirmed = await newConfirmModal(
				`Warning: Booking ${departed ? 'departed' : 'checked-in'}`,
				departed ? (
					<FormattedMessage
						id="booking-modification__departed-warning__body"
						defaultMessage="The booking you are trying to {action} has already departed. Do you still wish to continue?"
						values={{ action: cancellation ? 'cancel' : 'edit' }}
					/>
				) : (
					`The booking you are trying to ${cancellation ? 'cancel' : 'edit'} has already been checked in. Do you still wish to continue?`
				),
				{
					confirmText: 'Continue anyway',
					cancelText: 'Back',
					// Without this, "Back" rejects with no value. Nothing on this path catches it and
					// onEdit/onCancel are called as floating promises, so backing out of this warning
					// surfaced as an unhandled rejection — GlitchTip issues 389 and 399. Resolving
					// with false lands on the `if (!confirmed)` below, which is what it meant anyway.
					resolveOnCancel: true,
				},
			);
			if (!confirmed) {
				return false;
			}
		} else {
			newAlertModal(
				'Booking closed for modifications',
				departed ? (
					<FormattedMessage
						id="booking-modification__departed-closed__body"
						defaultMessage="The ferry trip associated to this booking has already departed."
					/>
				) : (
					'This booking has already been checked in.'
				),
				{
					cancelText: 'Refresh booking',
				},
			).finally(() => {
				if (!store.isStaff) {
					window.location.reload();
				}
			});
			return false;
		}
	}

	if (res.includes('cancelled')) {
		newAlertModal('Booking closed for modifications', 'This booking has already been cancelled.', {
			cancelText: 'Refresh booking',
		}).finally(() => {
			window.location.reload();
		});
		return false;
	}
	return true;
}
